import React, { Component } from 'react';
import { injectIntl } from '@atlassian/jira-intl';
import { selectIssueOption, Tooltip } from '@atlassian/jira-portfolio-3-common';
import type { OptionType } from '@atlassian/jira-portfolio-3-common/src/select/types';
import type { Issue } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/issues/types';
import SearchablePopupSelect from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/main/tabs/dependencies/popup-select/searchable';
import { isDefined } from '@atlassian/jira-portfolio-3-portfolio/src/common/ramda';
import messages from './messages';
import type { Props } from './types';

// eslint-disable-next-line jira/react/no-class-components
class IssueSelector extends Component<Props> {
	renderDependencyIssue = (issue: Issue) => {
		const { issueTypes } = this.props;
		const issueType = issueTypes.find(({ id }) => id === issue.type);
		return selectIssueOption({
			icon: issueType && issueType.iconUrl,
			label: this.getDependencyIssueValue(issue),
		});
	};

	getDependencyIssueValue = ({ issueKey, project: projectId, summary }: Issue) => {
		const { projectsById } = this.props;
		const project = projectsById[projectId || NaN];
		const key = isDefined(issueKey) ? `${project.key}-${issueKey}` : project.key;
		return `${key} ${summary}`;
	};

	loadOptions = (query: string) => {
		const q = query.toLowerCase();

		const issues: Issue[] = this.props.issues
			.filter((issue) => this.getDependencyIssueValue(issue).toLowerCase().includes(q))
			.slice(0, 50);
		return Promise.resolve(issues);
	};

	render() {
		const { intl, issues, issueId, rollupBy, onChangeDependencyIssue, isOpen } = this.props;
		const isRolledUp = isDefined(rollupBy) && rollupBy !== 'none';
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		const formatOptionLabel = (arg1: OptionType) => this.renderDependencyIssue(arg1 as Issue);

		const select = (
			<SearchablePopupSelect
				isAsync
				isOpen={isOpen}
				label={intl.formatMessage(messages.issueFilterLabel)}
				defaultOptions={issues.slice(0, 50)}
				value={issues.find((issue) => issue.id === issueId)}
				formatOptionLabel={formatOptionLabel}
				getOptionValue={this.getDependencyIssueValue}
				isDisabled={isRolledUp}
				loadOptions={this.loadOptions}
				onChange={onChangeDependencyIssue}
				searchPlaceholder={intl.formatMessage(messages.issueSelectorPlaceholder)}
				testId="portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.filters.issue.issue-selector"
			/>
		);

		if (isRolledUp) {
			return (
				<Tooltip content={intl.formatMessage(messages.issueFilterWithRollupNotSupported)}>
					{select}
				</Tooltip>
			);
		}
		return select;
	}
}

export default injectIntl(IssueSelector);
